import { createRootRoute, createRoute } from '@tanstack/react-router'
import { App } from '@/app/App'
import { IndexPage } from '@/pages/index/IndexPage'
import { CounterPage } from '@/pages/schetchik-simvolov/CounterPage'
import { DedupeLinesPage } from '@/pages/udalit-dubli-strok/DedupeLinesPage'
import { TextCleanupPage } from '@/pages/ochistit-tekst/TextCleanupPage'
import { PasswordGeneratorPage } from '@/pages/generator-parolej/PasswordGeneratorPage'
import { CaseConverterPage } from '@/pages/registr-teksta/CaseConverterPage'
import { SeoLimitsPage } from '@/pages/seo-limity/SeoLimitsPage'
import { TransliterationPage } from '@/pages/transliteraciya/TransliterationPage'
import { FancyTextPage } from '@/pages/krasivyy-tekst/FancyTextPage'
import { BlogIndexPage } from '@/pages/blog/BlogIndexPage'
import { BlogPostPage } from '@/pages/blog/BlogPostPage'

const rootRoute = createRootRoute({
  component: App,
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})

const textCounterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/schetchik-simvolov',
  component: CounterPage,
})

const dedupeLinesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/udalit-dubli-strok',
  component: DedupeLinesPage,
})

const textCleanupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/ochistit-tekst',
  component: TextCleanupPage,
})

const textCaseRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/registr-teksta',
  component: CaseConverterPage,
})

const passwordGeneratorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/generator-parolej',
  component: PasswordGeneratorPage,
})

const seoLimitsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/seo-limity',
  component: SeoLimitsPage,
})

const transliterationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/transliteraciya',
  component: TransliterationPage,
})

const fancyTextRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/krasivyy-tekst',
  component: FancyTextPage,
})

const blogIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog',
  component: BlogIndexPage,
})

const blogPostRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog/$slug',
  component: BlogPostPage,
})

export const routeTree = rootRoute.addChildren([
  indexRoute,
  textCounterRoute,
  dedupeLinesRoute,
  textCleanupRoute,
  textCaseRoute,
  passwordGeneratorRoute,
  seoLimitsRoute,
  transliterationRoute,
  fancyTextRoute,
  blogIndexRoute,
  blogPostRoute,
])
